export type Address = Components.Schemas.Address;

export const emptyAddress = (): Address => ({
	id: '',
	address1: '',
	address2: '',
	locality: '',
	stateProvinceRegion: '',
	postalCode: '',
	countryCode: '',
});
